import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./intro.scss";

type IProps = {};

export default function JoinIntro({}: IProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <h1>{t("ttl_sgn")}</h1>
      <p className="text-blue-300 text-center text-xs md:text-sm">
        {t("ttl_dscrp_sng_stp_1")}
      </p>
      <div className="progress-bar">
        <span className={"step0"} />
      </div>

      <div className="intro-desc">
        <p>{t("dscrp_sgn_1")}</p>
        <p>{t("dscrp_sgn_2")}</p>
        <p>{t("dscrp_sgn_3")}</p>
      </div>
      <button
        className="btn w-full"
        onClick={() => {
          navigate("term");
        }}
      >
        {t("lnk_eml_sng")}
      </button>
      <div className="btn-wrap">
        <button className="btn apple">Apple&nbsp;{t("btn_id_lgi")}</button>
        <button className="btn google">Goole&nbsp;{t("btn_id_lgi")}</button>
      </div>
    </>
  );
}
